import { showToast } from '@app/providers/ToastProvider';

const copyToClipboard = (value: string) => {
	navigator?.clipboard?.writeText(value);

	showToast.success('Copied successfully.');
};

export default copyToClipboard;
